/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const accountModule = require('@utils/account/accountModule');
const analyticsModule = require('@utils/analytics/analyticsModule');
const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const categoriesModule = require('@utils/categories/categoriesModule');
const getFetchModule = require('@utils/get_fetch/getFetchModule');
const indexModule = require('@utils/index/indexModule');
const productModule = require('@utils/product/productModule');
const rebatesMdoule = require('@utils/rebates/rebatesModule');
const utilitySelectorModule = require('@utils/utility_selector/utilitySelectorModule');

const ProductCardService = require('./productCardService');
const cardDirective = require('./cardDirective');
const certBadgesDirective = require('./components/certBadges/certBadgesDirective');
const descriptionDirective = require('./components/description/descriptionDirective');
const displayNameDirective = require('./components/displayName/displayNameDirective');
const favoriteDirective = require('./components/favorite/favoriteDirective');
const imageDirective = require('./components/image/imageDirective');
const offersBoxDirective = require('./components/offers/box/offersBoxDirective');
const offersButtonDirective = require('./components/offers/button/offersButtonDirective');
const optionsDirective = require('./components/options/optionsDirective');
const platformsDirective = require('./components/platforms/platformsDirective');
const priceDropMessageDirective = require('./components/price/priceDrop/priceDropMessageDirective');
const basePriceDirective = require('./components/price/basePriceDirective');
const ratingDirective = require('./components/rating/ratingDirective');
const rebateTagDirective = require('./components/rebateTag/rebateTagDirective');
const recommendedTagDirective = require('./components/recommendedTag/recommendedTagDirective');
const tagDirective = require('./components/tags/tagsDirective');
const compareButtonDirective = require('./components/compare/compareButtonDirective');

const productCardModule = angular
    .module('enervee_utils.product_card', [
        accountModule.name,
        analyticsModule.name,
        categoriesModule.name,
        cmsModule.name,
        commonModule.name,
        getFetchModule.name,
        indexModule.name,
        productModule.name,
        rebatesMdoule.name,
        utilitySelectorModule.name,
    ])
    .factory('ProductCardService', ProductCardService)
    .directive('productCardCertBadges', certBadgesDirective)
    .directive('productCardDescription', descriptionDirective)
    .directive('productCardDisplayName', displayNameDirective)
    .directive('productCardFavorite', favoriteDirective)
    .directive('productCardImage', imageDirective)
    .directive('productCardOffersBox', offersBoxDirective)
    .directive('productCardOffersButton', offersButtonDirective)
    .directive('productCardCompareButton', compareButtonDirective)
    .directive('productCardOptions', optionsDirective)
    .directive('productCardPlatforms', platformsDirective)
    .directive('productCardPriceDropMessage', priceDropMessageDirective)
    .directive('productCardBasePrice', basePriceDirective)
    .directive('productCardRating', ratingDirective)
    .directive('productCardRebateTag', rebateTagDirective)
    .directive('productCardRecommendedTag', recommendedTagDirective)
    .directive('productCardTagDirective', tagDirective)
    .directive('productCard', cardDirective);

module.exports = productCardModule;
